import _ from 'lodash'

var DataValidation = {
  methods: {
    validateRequireField(options) {
      var attribute = options.attribute
      var value = options.value
      var message = options.message ? options.message : 'Required'
      var dataToValidate = value ? value : this.$data[attribute]
      if (!dataToValidate) {
        this.errors[attribute] = message
      } else {
        this.errors[attribute] = null
      }
    },
    validateStringLength(options) {
      var attribute = options.attribute
      var value = options.value
      var dataToValidate = _.includes(_.keys(options), 'value') ? value : this.$data[attribute]
      dataToValidate = _.trim(dataToValidate)
      var length = _.size(dataToValidate)

      if (!dataToValidate) {
        this.errors[attribute] = 'Required'
        return
      }

      var lowerMessage = options.lowerMessage ? options.lowerMessage : 'Required'
      var minium = typeof options.min === 'number' ? options.min : -Infinity
      var maximum = typeof options.max === 'number' ? options.max : Infinity
      var upperMessage = options.upperMessage ? options.upperMessage : `${maximum} characters maximum`
      if (length > maximum){
        this.errors[attribute] = upperMessage
      } else if(length < minium) {
        this.errors[attribute] = lowerMessage
      } else {
        this.errors[attribute] = null
      }
    },
    validateNumber(options) {
      var attribute = options.attribute
      var value = options.value
      var dataToValidate = (value || value == 0) ? value : this.$data[attribute]

      if (dataToValidate !== 0 && !dataToValidate) {
        this.errors[attribute] = 'Required'
        return
      }

      var upperMessage = options.upperMessage ? options.upperMessage : 'Invalid'
      var lowerMessage = options.lowerMessage ? options.lowerMessage : 'Required'
      var minium = typeof options.min === 'number' ? options.min : -Infinity
      var maximum = typeof options.max === 'number' ? options.max : Infinity

      if (dataToValidate > maximum) {
        this.errors[attribute] = upperMessage
      } else if(dataToValidate < minium) {
        this.errors[attribute] = lowerMessage
      } else {
        this.errors[attribute] = null
      }
    }
  }
}

export default DataValidation;
